export const isMobile = () => {
  let mobileDevice = false;
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator?.userAgent)) {
    mobileDevice = true;
  }
  return mobileDevice;
};
